import React from "react";
import JsxParser from "react-jsx-parser/lib/es5/react-jsx-parser.min.js";
import "rc-switch/assets/index.css";

import { CSCContext } from "../CSCContext";

import Page from "./Page";
import ImageButtonGrid from "./ImageButtonGrid";
import ImageButton from "./ImageButton";
import NumberInput from "./NumberInput";
import PageControls from "./PageControls";
import SwitchInput from "./SwitchInput";
import SliderInput from "./SliderInput";
import CalculatedNumberDisplay from "./CalculatedNumberDisplay";
import MarketoForm from "./MarketoForm";

const pageDataFile = 'csc.jsx';

class App extends React.PureComponent {
	constructor(props) {
		super(props);

		this.pageData = null;

		this.state = {
			currentPage: 0,
			errorName: "",
			errorMessage: "",
		};
	}

	componentDidMount() {
		this.fetchPageData().then((data) => {
			this.pageData = data;

			// set the page number so we can re-render
			// after receiving the page data
			this.setState({ currentPage: 1 });
		});
	}

	async fetchPageData() {
		let data = {};

		try {
			let response = await fetch(pageDataFile);
			if (!response.ok) {
				throw new Error("network connection failed");
			}
			data = await response.text();
			return data;
		} catch (error) {			
			error.name = `Failed to Fetch page data from ${pageDataFile}`;
			this.onError(error);
		}
	}

	prevPage = () => {
		if (this.state.currentPage > 1) {
			this.setState({
				currentPage: this.state.currentPage - 1,
			});

			window.scrollTo(0, 0);
			return true;
		}

		return false;
	};

	nextPage = () => {
		this.setState({
			currentPage: this.state.currentPage + 1,
		});
		window.scrollTo(0, 0);

		return true;
	};

	setUserData = (name, value) => {
		if (value !== '') {
			this.setState({
				[name]: value
			});
		}
	};

	getUserData = (name) => {
		if (name != null) {
			return this.state[name];
		}
		else { // return ALL user data
			return this.state;
		}
	};

	onError = (error) => {
		console.error(`${error.name}: \n${error.description}`);
		this.setState({
			errorName: error.name,
			errorMessage: error.description,
		});
	}

	render() {
		if (this.state.errorName || this.state.errorMessage) {
			return (
				<p className="error-message">
					<em>Oops!</em> Something went wrong.
				</p>
			);
		}

		return (
			<React.Fragment>
				<CSCContext.Provider value={{ 
					getUserData: this.getUserData, 
					setUserData: this.setUserData, 
					currentPage: this.state.currentPage, 
					prevPage: this.prevPage, 
					nextPage: this.nextPage,
					onImageButtonClick: this.nextPage,
				}}>
					<JsxParser
						components={{ Page, ImageButtonGrid, ImageButton, SliderInput, NumberInput, SwitchInput, CalculatedNumberDisplay, MarketoForm, PageControls }}
						blacklistedAttrs={[]}
						jsx={this.pageData}
						renderInWrapper={false}
						showWarnings={true}
						disableKeyGeneration={true}
						renderError={e => {
							this.onError({
								name: `Error parsing page data from ${pageDataFile}`,
								description: e.error,
							});
						}}
					/>
				</CSCContext.Provider>
			</React.Fragment>
		);
	}
}

export default App;
